<div class="flex justify-end min-h-screen">
    <!-- Background gradient Dr.Feel -->
    <div class="fixed inset-0 w-full h-full flex-grow max-lg:hidden">
        <div class="-z-50 absolute inset-0 w-[calc(100%-612px)] h-full bg-drfeel-gradient"></div>
        <img class="w-full h-full object-cover" src="images/screen-mockup.png" alt="Mockup Dr.Feel">
    </div>
    <!-- Content -->
    <div class="z-50 flex-grow w-full lg:max-w-[612px] bg-white pt-[68px] pb-[25px] px-5 lg:px-[138px]">
        <div class="w-full max-w-[336px] mx-auto">
            <div class="flex items-end gap-[6px] mb-10">
                <img class="" src="images/logo-drfeel-gradient.svg" alt="Logo Dr.Feel">
            </div>
            <div class="flex items-center gap-[25px] mb-[35px]">
                <app-icon class="cursor-pointer" name="back" [width]="11" [height]="20" color="none" (click)="goBack()"></app-icon>
                <h3 class="text-sm leading-[135%] text-lightBlack font-bold">Verifica la tua idoneità</h3>
            </div>
            <img src="images/ermenegildo-zegna-group.png" alt="Ermenegildo Zegna Group" class="max-h-10 mb-[13px]" />
            <h1 class="text-[25px] leading-[32px] text-lightBlack font-black mb-[14px]">Inserisci i dati richiesti</h1>
            <p class="text-base leading-[135%] text-gray font-medium mb-[14px]">I tuoi dati ci servono per capire se la tua azienda ti offre il servizio Dr.Feel.</p>
        
            <!-- Form -->
            <form class="flex flex-col gap-5 mb-[23px]" [formGroup]="userInfoForm" (ngSubmit)="onSubmit()">
    
                <!-- Nome -->
                <div class="flex flex-col">
                    <label for="firstName" class="mb-2 text-[15px] text-darkGray font-black">Nome</label>
                    <input id="firstName" type="text" formControlName="firstName" class="rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition" placeholder="Inserisci il tuo nome"/>
                    <div *ngIf="!userInfoForm.get('firstName')?.hasError('nameMismatch') && !userInfoForm.get('firstName')?.hasError('minLength') && userInfoForm.get('firstName')?.invalid && userInfoForm.get('firstName')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Per favore inserisci il tuo nome.
                    </div>
                    <div *ngIf="userInfoForm.get('firstName')?.hasError('minLength') && userInfoForm.get('firstName')?.invalid && userInfoForm.get('firstName')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Lunghezza minima: 2 caratteri
                    </div>
                    <div *ngIf="userInfoForm.get('firstName')?.hasError('nameMismatch') && userInfoForm.get('firstName')?.invalid && userInfoForm.get('firstName')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Il nome non corrisponde all'Employee ID inserito.
                    </div>
                </div>
                
                <!-- Cognome -->
                <div class="flex flex-col">
                    <label for="lastName" class="mb-2 text-[15px] text-darkGray font-black">Cognome</label>
                    <input id="lastName" type="text" formControlName="lastName" class="rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition" placeholder="Inserisci il tuo cognome"/>
                    <div *ngIf="!userInfoForm.get('lastName')?.hasError('nameMismatch') && !userInfoForm.get('lastName')?.hasError('minLength') && userInfoForm.get('lastName')?.invalid && userInfoForm.get('lastName')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Per favore inserisci il tuo cognome.
                    </div>
                    <div *ngIf="userInfoForm.get('lastName')?.hasError('minLength') && userInfoForm.get('lastName')?.invalid && userInfoForm.get('lastName')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Lunghezza minima: 2 caratteri
                    </div>
                    <div *ngIf="userInfoForm.get('lastName')?.hasError('nameMismatch') && userInfoForm.get('lastName')?.invalid && userInfoForm.get('lastName')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Il cognome non corrisponde all'Employee ID inserito.
                    </div>
                </div>

                <!-- Sesso -->
                <div class="flex flex-col">
                    <label for="gender" class="mb-2 text-[15px] text-darkGray font-black">Sesso</label>
                    <div class="relative">
                        <select id="gender" formControlName="gender"
                            class="appearance-none w-full border border-lightGray bg-lightGray rounded-lg px-4 py-4 
                                   focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition 
                                   text-lightBlack text-[15px] leading-[19px] font-bold">
                            <option class="text-[15px] leading-[15px]" value="" disabled>Seleziona il sesso</option>
                            <option class="text-[15px] leading-[15px]" value="MALE">Uomo</option>
                            <option class="text-[15px] leading-[15px]" value="FEMALE">Donna</option>
                        </select>
                
                        <div class="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <app-icon name="dropdown" [width]="19" [height]="12" color="none"></app-icon>    
                        </div>
                    </div>
                    <div *ngIf="userInfoForm.get('gender')?.invalid && userInfoForm.get('gender')?.touched" 
                         class="text-red-500 text-sm mt-1">
                        Per favore inserisci il tuo sesso.
                    </div>
                </div>
                
                <!-- Data di nascita -->
                <div class="flex flex-col">
                    <label class="mb-2 text-[15px] text-darkGray font-black">Data di nascita (formato: 31-12-1970)</label>
                    <div class="flex gap-2">
                      <div class="w-1/3">
                        <input
                          type="number"
                          formControlName="birthDay"
                          placeholder="Giorno"
                          min="1"
                          max="31"
                          class="w-full rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition"
                          [ngClass]="{'border-2 border-rose-500': birthDay?.invalid && birthDay?.touched}"
                        />
                      </div>
                      <div class="w-1/3">
                        <input
                          type="number"
                          formControlName="birthMonth"
                          placeholder="Mese"
                          min="1"
                          max="12"
                          class="w-full rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition"
                          [ngClass]="{'border-2 border-rose-500': birthMonth?.invalid && birthMonth?.touched}"
                        />
                      </div>
                      <div class="w-1/3">
                        <input
                          type="number"
                          formControlName="birthYear"
                          placeholder="Anno"
                          min="1900"
                          [max]="currentYear"
                          class="w-full rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition"
                          [ngClass]="{'border-2 border-rose-500': birthYear?.invalid && birthYear?.touched}"
                        />
                      </div>
                    </div>
                    <div *ngIf="(birthDay?.invalid && birthDay?.touched) || (birthMonth?.invalid && birthMonth?.touched) || (birthYear?.invalid && birthYear?.touched)" class="text-red-500 text-xs mt-1">
                      Per favore inserisci una data di nascita valida.
                    </div>
                    <div *ngIf="isAdultUser === false" class="text-red-500 text-xs mt-1">
                        Per utilizzare il servizio bisogna essere maggiorenni.
                    </div>
                </div>
                
                <!-- Stato di nascita -->
                <div class="flex flex-col">
                    <label for="birthCountry" class="mb-2 text-[15px] text-darkGray font-black">Stato di nascita</label>
                    <div class="relative">
                        <select id="birthCountry" formControlName="birthCountry"
                            class="appearance-none w-full border border-lightGray bg-lightGray rounded-lg px-4 py-4 
                                   focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition 
                                   text-lightBlack text-[15px] leading-[19px] font-bold">
                            <option class="text-[15px] leading-[15px]" value="" disabled>Seleziona lo Stato di nascita</option>
                            <option class="text-[15px] leading-[15px]" value="Italia">Italia</option>
                            <option class="text-[15px] leading-[15px]" value="Estero">Estero</option>
                        </select>
                
                        <div class="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <app-icon name="dropdown" [width]="19" [height]="12" color="none"></app-icon>    
                        </div>
                    </div>
                </div>
                
                
                <!-- Provincia e Comune di nascita (se Italia) -->
                <div>
                    <div class="flex gap-2" *ngIf="userInfoForm.get('birthCountry')?.value === 'Italia'">
                        <!-- Provincia -->
                        <div class="w-1/2 flex flex-col" *ngIf="userInfoForm.get('birthCountry')?.value === 'Italia'">
                            <label for="birthProvince" class="mb-2 text-[15px] text-darkGray font-black">Provincia di nascita</label>
                            <div class="relative">
                                <select id="birthProvince" formControlName="birthProvince" class="appearance-none w-full border border-lightGray bg-lightGray rounded-lg px-4 py-4 focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition text-lightBlack text-[15px] leading-[19px] font-bold" (change)="onProvinceChange($event)">
                                    <option class="text-[15px] leading-[15px]" value="" disabled>Seleziona la provincia</option>
                                    <option *ngFor="let province of provinces" [value]="province.sigla">{{ province.denominazione }}</option>
                                </select>
                                <div class="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    <app-icon name="dropdown" [width]="19" [height]="12" color="none"></app-icon>   
                                </div>
                            </div>
                        </div>
                        <!-- Comune -->
                        <div class="w-1/2 flex flex-col" *ngIf="userInfoForm.get('birthProvince')?.value">
                            <label for="birthCity" class="mb-2 text-[15px] text-darkGray font-black">Comune di nascita</label>
                            <input id="birthCity" type="text" formControlName="birthCity" class="rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition" placeholder="Inserisci il comune" />
                        </div>
                    </div>
                    <div *ngIf="(userInfoForm.get('birthProvince')?.invalid && userInfoForm.get('birthProvince')?.touched)" class="text-red-500 text-xs mt-1">
                        Per favore inserisci la tua provincia di nascita.
                    </div>
                    <div *ngIf="(userInfoForm.get('birthCity')?.invalid && userInfoForm.get('birthCity')?.touched)" class="text-red-500 text-xs mt-1">
                        Per favore inserisci il tuo comune di nascita.
                    </div>
                </div>
                
                <!-- Luogo di nascita (se Estero) -->
                <div class="flex flex-col -mt-5" *ngIf="userInfoForm.get('birthCountry')?.value === 'Estero'">
                    <label for="birthPlace" class="mb-2 text-[15px] text-darkGray font-black">Luogo di nascita</label>
                    <input id="birthPlace" type="text" formControlName="birthPlace" class="rounded-lg px-4 py-4 bg-lightGray text-[15px] leading-[15px] font-bold focus:outline-none focus:ring-2 focus:ring-drfeel focus:border-drfeel transition" placeholder="Inserisci il luogo di nascita" />
                    <div *ngIf="(userInfoForm.get('birthPlace')?.invalid && userInfoForm.get('birthPlace')?.touched)" class="text-red-500 text-xs mt-1">
                        Per favore inserisci il tuo luogo di nascita.
                    </div>
                </div>
                
                <button type="submit" [disabled]="userInfoForm.invalid" class="mt-[5px] w-full bg-drfeel py-4 rounded-[5px] text-white text-[18px] uppercase font-bold disabled:opacity-20 disabled:cursor-not-allowed">
                    Conferma
                </button>
                
            </form>
            
            <p class="text-darkGray text-[12px] leading-normal font-medium mb-[69px] lg:mb-[122px]">ATTENZIONE: Ermenegildo Zegna Group, in virtù della convenzione sottoscritta, controllerà periodicamente la validità dell'iscrizione o appartenenza all'Azienda o l'Ente e, in caso di irregolarità, il servizio verrà disattivato. Per le informazioni sul trattamento di dati personali si rimanda alla pagina <a class="underline" href="https://drfeel.com/assets/pdf/Privacy_Policy_DrFeel.pdf" target="_blank">Informativa Privacy</a>.</p>
            <div>
                <app-icon name="help" [width]="29" [height]="17" color="none"></app-icon>
                <h3 class="mt-[10px] text-lightBlack text-[12px] leading-[18px] font-black">Dubbi o domande?</h3>
                <p class="text-lightBlack text-[12px] leading-[18px] font-medium">Per informazioni o supporto in merito all'attivazione o sul servizio, contatta Dr.Feel all'indirizzo e-mail <a class="font-bold" href="mailto:assistenza@drfeel.com">assistenza&#64;drfeel.com</a> o via <a class="font-bold" href="https://api.whatsapp.com/send?phone=393757347706" target="_blank">WhatsApp</a></p>
                    
            </div>
        </div>
    </div>
</div>
